import { render, staticRenderFns } from "./flowApproval.vue?vue&type=template&id=2f5b82cf&scoped=true"
import script from "./flowApproval.vue?vue&type=script&lang=js"
export * from "./flowApproval.vue?vue&type=script&lang=js"
import style0 from "./flowApproval.vue?vue&type=style&index=0&id=2f5b82cf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5b82cf",
  null
  
)

export default component.exports